export const MAX_PDF_BYTES = 20 * 1024 * 1024;
//# sourceMappingURL=contrato.js.map